<template>
  <section>
    <tabsLayout>
      <b-tabs
        :value="currentTabIndex"
        card
        lazy
        active-nav-item-class="font-weight-bold"
        content-class="my-0"
      >
        <b-tab
          v-for="tab of filterTabs"
          :key="tab.key"
          :title="tab.label"
          @click="$router.push({ name: tab.key })"
          class="px-0"
        >
        </b-tab>
      </b-tabs>
      <listLayout>
        <router-view></router-view>
      </listLayout>
    </tabsLayout>
  </section>
</template>

<script>
import tabsLayout from "@/layout/TabsLayout.vue";
import listLayout from "@/layout/ListLayout.vue";

const tabs = [
  {
    key: "newlyAddedNewsAll",
    label: "所有新聞"
  },
  {
    key: "newlyAddedSurveyAll",
    label: "所有研究報告"
  }
];
export default {
  components: {
    tabsLayout,
    listLayout
  },
  beforeRouteUpdate(to, from, next) {
    //不能用 from path，會取到上一個 currentTabIndex
    const tabName = to.path.split("/")[2];
    this.currentTabIndex = this.howIsCurrentTabIndex(tabName);
    next();
  },
  created() {
    const tabName = this.$route.path.split("/")[2];
    this.currentTabIndex = this.howIsCurrentTabIndex(tabName);
  },
  data() {
    return {
      currentTabIndex: 0
    };
  },
  computed: {
    filterTabs() {
      return tabs;
    }
  },
  methods: {
    howIsCurrentTabIndex(tabName) {
      return this.filterTabs.findIndex(item => {
        return item.key === tabName;
      });
    }
  }
};
</script>
<style scoped lang="scss">
// ::v-deep .nav-tabs .nav-item {
//   width: 15%;
//   text-align: center;
// }
// ::v-deep .nav-tabs .nav-item:nth-child(5) {
//   margin-left: auto;
// }
// ::v-deep .nav-tabs .nav-item:nth-child(11) {
//   margin-left: auto;
// }
</style>
